import { render, staticRenderFns } from "./fromInfo.vue?vue&type=template&id=4fe67850&scoped=true&"
import script from "./fromInfo.vue?vue&type=script&lang=js&"
export * from "./fromInfo.vue?vue&type=script&lang=js&"
import style0 from "./fromInfo.vue?vue&type=style&index=0&id=4fe67850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe67850",
  null
  
)

export default component.exports